export default __webpack_public_path__ + "static/media/sample1.83657e35.png";